import {
  HTTP_GETFORECASTLIST2_FETCHING,
  HTTP_GETFORECASTLIST2_SUCCESS,
  HTTP_GETFORECASTLIST2_FAILED,
  HTTP_RESET_FORECASTLIST2,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETFORECASTLIST2_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETFORECASTLIST2_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETFORECASTLIST2_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    case HTTP_RESET_FORECASTLIST2:
      return initialState;
    default:
      return state;
  }
};
